// Splits `text` on `query` and bolds the matching segments, for typeahead
// dropdowns. The query is user input on its way into a RegExp, so it has to be
// escaped first - an unescaped "(" throws SyntaxError during render and blanks
// the page.
import React from 'react';

export const escapeRegExp = query =>
  query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const highlightMatch = (query, text) => {
  if (!query || !text) return [text];

  return text
    .split(new RegExp(`(${escapeRegExp(query)})`, 'i'))
    .map((segment, index) =>
      segment.toLowerCase() === query.toLowerCase() ? (
        /* eslint-disable-next-line react/no-array-index-key */
        <strong key={`${segment}-${index}`}>{segment}</strong>
      ) : (
        segment
      )
    );
};
